import script from "./TableViewTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableViewTabs.vue?vue&type=script&setup=true&lang=ts"

import "./TableViewTabs.vue?vue&type=style&index=0&id=4da4037c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da4037c"]])

export default __exports__